<template>
  <nav>
      <div class="d-flex flex-row align-items-center justify-content-around footer">
          <div class="footer-img">
          </div>
  
          
          <div class="d-flex align-items-center justify-content-center footer-box" >
              <div id="item-box" class="item-box" :class="route.includes('/search') ? 'show' : ''" v-if="route.includes('/search')">
                  <div class="d-flex justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center" >
                          <router-link to="/search/stacker" >
                              <img :src="require(`../assets/img/${route == '/search/stacker' ? 'layers-active.png' : 'layers.png'}`)" class="inner-icons"/>
                          </router-link>
                      </div>
                      <div class="d-flex justify-content-center align-items-center" >
                          <router-link to="/search/filter">
                              <img :src="require(`../assets/img/${route == '/search/filter' ? 'list-active.png' : 'list.png'}`)" class="inner-icons"/>
                          </router-link>
                      </div>
                      <div class="d-flex justify-content-center align-items-center" >
                          <router-link to="/search/keypad">
                              <img :src="require(`../assets/img/${route == '/search/keypad' ? 'keypad-active.png' : 'keypad.png'}`)" class="inner-icons"/>
                          </router-link>
                      </div>
                      <div @click="CloseItems()" class="d-flex justify-content-center cursor-pointer align-items-center arrow">
                          <img :src="require(`../assets/img/arrow-back-white.png`)"  class="inner-icons"/>
                      </div>
                  </div>
              </div>
              <router-link to="/search/stacker" v-on:mouseover="OpenItems">
                  <img  class="footer-icons" :src="require(`../assets/img/${route.includes('search') ? 'search-active.png' :'search.png'}`)"  />
                  <span class="name" :class="{ 'nav-active': route.includes('/search') }">Search</span>
              </router-link>
          </div>
  
          <div class="d-flex align-items-center justify-content-center footer-box" >
               <div id="gallery-box" class="gallery-box" :class="route.includes('/gallery') ? 'show' : ''" v-if="route.includes('/gallery')">
                  <div class="d-flex justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center" >
                          <span @click="GalleryCategory(`layers`)">
                              <img :src="require(`../assets/img/${this.Gallery == 'layers' ? 'building-yellow.png' : 'building-white.png'}`)"  class="inner-icons"/>
                          </span>
                      </div>
                      <div class="d-flex justify-content-center align-items-center" >
                          <span @click="GalleryCategory(`interior`)">
                              <img :src="require(`../assets/img/${this.Gallery == 'interior' ? 'couch-yellow.png' : 'couch-white.png'}`)"   class="inner-icons"/>
                          </span>
                      </div>
                      <div class="d-flex justify-content-center align-items-center" >
                          <span @click="GalleryCategory(`env`)">
                              <img :src="require(`../assets/img/${this.Gallery == 'env' ? 'tree-yellow.png' : 'tree-white.png'}`)"   class="inner-icons leaf"/>
                          </span>
                      </div>
                      <!-- <div class="d-flex justify-content-center align-items-center" >
                          <span @click="GalleryCategory(`videoplayer`)">
                              <img :src="require(`../assets/img/${this.Gallery == 'videoplayer' ? 'tv-blue.png' : 'tv-white.png'}`)"  class="inner-icons"/>
                          </span>
                      </div> -->
  
                      <div @click="CloseGallery()" class="d-flex justify-content-center align-items-center arrow">
                          <img :src="require(`../assets/img/arrow-back-white.png`)"  class="inner-icons"/>
                      </div>
                  </div>
               </div>
              
              <router-link to="/gallery" v-on:mouseover="OpenGallery" v-on:touchstart="OpenGallery">
                  <img  class="footer-icons" :src="require(`../assets/img/${route.includes('gallery') ? 'gallery-active.png' :'gallery.png'}`)"/>
                  <span class="name">Gallery</span>
              </router-link>
          </div>

          <div class="d-flex align-items-center justify-content-center footer-box" >
              <div id="virtual-box" class="virtual-box" :class="route.includes('/VirtualTour') ? 'show' : ''" v-if="route.includes('/VirtualTour')">
                  <div class="d-flex justify-content-center align-items-center">

                        <div class="d-flex justify-content-center align-items-center" >
                          <span @click="VirtualCategory(`OneRoom`)">
                              <img :src="require(`../assets/img/${this.Virtual == 'OneRoom' ? 'door-yellow.png' : '1b.png'}`)"   class="inner-icons leaf"/>
                          </span>
                        </div>

                        <div class="d-flex justify-content-center align-items-center" >
                          <span @click="VirtualCategory(`TwoRoom`)">
                              <img :src="require(`../assets/img/${this.Virtual == 'TwoRoom' ? 'door-yellow.png' : '2bi.png'}`)"   class="inner-icons leaf"/>
                          </span>
                        </div>

                        <div class="d-flex justify-content-center align-items-center" >
                          <span @click="VirtualCategory(`ThreeRoom`)">
                              <img :src="require(`../assets/img/${this.Virtual == 'ThreeRoom' ? 'door-yellow.png' : '2bii.png'}`)"  class="inner-icons leaf"/>
                          </span>
                        </div>
                      
                      <div @click="CloseVirtual()" class="d-flex justify-content-center align-items-center arrow">
                          <img :src="require(`../assets/img/arrow-back-white.png`)"  class="inner-icons"/>
                      </div>
                  </div>
               </div> 
              
              <router-link to="/VirtualTour" v-on:mouseover="OpenVirtual" v-on:touchstart="OpenVirtual">
                  <img  class="footer-icons"  :src="require(`../assets/img/${route.includes('VirtualTour') ? 'vr-active.png' :'vr.png'}`)"/>
                  <span class="name">Virtual Tour </span>
              </router-link>
          </div>
  
          <div class="d-flex align-items-center justify-content-center footer-box" >
              <div id="specs-box" class="specs-box" :class="route.includes('/specs') ? 'show' : ''" v-if="route.includes('/specs')">
                  <div class="d-flex justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center" >
                          <span @click="SpecsCategory(`kitchen`)">
                              <img :src="require(`../assets/img/${this.Specs == 'kitchen' ? 'kitchen-active.png' : 'kitchen.png'}`)"  class="inner-icons"/>
                          </span>
                      </div>
                      <div class="d-flex justify-content-center align-items-center" >
                          <span @click="SpecsCategory(`bathroom`)">
                              <img :src="require(`../assets/img/${this.Specs == 'bathroom' ? 'toilet-active.png' : 'toilet.png'}`)"   class="inner-icons"/>
                          </span>
                      </div>

                      <div class="d-flex justify-content-center align-items-center" >
                          <span @click="SpecsCategory(`general`)">
                              <img :src="require(`../assets/img/${this.Specs == 'general' ? 'door-yellow.png' : 'door-white.png'}`)"   class="inner-icons leaf"/>
                          </span>
                      </div>
                      
                      <div @click="CloseSpecs()" class="d-flex justify-content-center align-items-center arrow">
                          <img :src="require(`../assets/img/arrow-back-white.png`)"  class="inner-icons"/>
                      </div>
                  </div>
               </div> 
              
              <router-link to="/specs" v-on:mouseover="OpenSpecs" v-on:touchstart="OpenSpecs">
                  <img  class="footer-icons"  :src="require(`../assets/img/${route.includes('specs') ? 'specs-yellow.png' :'specs-white.png'}`)"/>
                  <span class="name">Specifications </span>
              </router-link>
          </div>
  
          <!-- <div class="d-flex align-items-center justify-content-center footer-box" >
              <router-link to="/options">
                  <img  class="footer-icons"  :src="require(`../assets/img/${route.includes('options') ? 'specs-active.png' :'specs.png'}`)"/>
                  <span class="name">Options </span> 
              </router-link>
          </div> -->
  
          <div class="d-flex align-items-center justify-content-center footer-box" >
  
              <div id="location-box" class="location-box" :class="route.includes('/location') ? 'show' : ''" v-if="route.includes('/location')">
                  <div class="d-flex justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center " >
                          <span @click="LocationCategory(`map`)" >
                              <img :src="require(`../assets/img/${this.Location == 'map' ? 'locate-yellow.png' : 'locate-white.png'}`)"  class="inner-icons leaf"/>
                          </span>
                      </div>
                      <div class="d-flex justify-content-center align-items-center " >
                          <span @click="LocationCategory(`direction`)" >
                              <img :src="require(`../assets/img/${this.Location == 'direction' ? 'map-yellow.png' : 'map-white.png'}`)"   class="inner-icons "/>
                          </span>
                      </div>

                      <div class="d-flex justify-content-center align-items-center " >
                          <span @click="LocationCategory(`underground`)" >
                              <img :src="require(`../assets/img/${this.Location == 'underground' ? 'underground-yellow.png' : 'underground-white.png'}`)"   class="inner-icons "/>
                          </span>
                      </div>
                      
                      <div @click="CloseLocation()" class="d-flex justify-content-center align-items-center arrow">
                          <img :src="require(`../assets/img/arrow-back-white.png`)"  class="inner-icons"/>
                      </div>
                  </div>
               </div>
  
              <router-link to="/location" v-on:mouseover="OpenLocation" v-on:touchstart="OpenLocation">
                  <img  class="footer-icons"  :src="require(`../assets/img/${route.includes('location') ? 'location-active.png' :'location.png'}`)"/>
                  <span class="name">Location</span>
              </router-link>
          </div>
  
          <div class="footer-img rightfooter">
              
          </div>
  
          <div class="d-flex align-items-center justify-content-center footer-box ">
              <router-link to="/favourites" class="favourites"> 
                  <img  class="footer-icons star" :src="require(`../assets/img/${route.includes('favourites') ? 'star-active.png' :'star.png'}`)"/>
              </router-link>
  
              <span class="SideMenuButton" id="SideMenuButton" @click="toggleMenu(); showMenu = !showMenu">
                  <img v-if="showMenu == false" class="footer-icons" src="../assets/img/setting.png"/>
                  <img v-if="showMenu == true" class="footer-icons" src="../assets/img/setting-active.png"/>
              </span>
          </div>
         
      </div>
  </nav>
  </template>
  
  <script>
  
  import { SpecService,GalleryService,VirtualService,LocationService,GalleryReturnSubject } from "../services/spec.service";
  
  export default {
      name: "Footer",
      created(){
          this.subscription = SpecService.getMessage().subscribe(message => {
              setTimeout(()=>{
                  this.Specs = message.text;
              })
          });
  
          this.subscription = GalleryReturnSubject.getMessage().subscribe(message => {
  
              console.log(message.text);
              if(message.text == "galleryreset"){
                this.Gallery = "layers";
              }
  
              if(message.text == "specreset"){
                this.Specs = "kitchen";
              }
              if(message.text == "locationreset"){
                this.Location = "map";
              }

              if(message.text == "virtualreset"){
                this.Virtual = "OneRoom";
              }
  
              if(message.text == "CloseSideMenu"){
                  this.toggleMenu();
              }
          });
  
         
      },
      data() {
          return {
          route: "",
          showMenu: false,
          Gallery:"layers",
          Specs: 'kitchen',
          Location: 'map',
          Virtual: 'OneRoom'
          };
      },    
      watch: {
          $route(to, from) {
              this.route = to.fullPath;
          },
      },
      methods:{
          toggleMenu() {
          this.$emit("toggle-menu");
          },
            GalleryCategory(e) {
                GalleryService.sendMessage(e);
                this.Gallery = e;
            },
            SpecsCategory(e) {
                SpecService.sendMessage(e);
                this.Specs = e;
            },
            VirtualCategory(e) {
                console.log(e);
                VirtualService.sendMessage(e);
                this.Virtual = e;
            },
            LocationCategory(e) {
                LocationService.sendMessage(e);
                this.Location = e;
            },
  
          CloseItems(){
              let modal = document.getElementById("item-box");
              if(modal !== null){
                  //modal.style.display = "none";
                  modal.classList.remove("show");
              }
          },
          OpenItems: function(){
              let items = document.getElementById("item-box");
              if(items !== null){
                  //items.style.display = "";
                  items.classList.add("show");
              }
          },
  
          CloseGallery(){
              let modal = document.getElementById("gallery-box");
              if(modal !== null){
                  //modal.style.display = "none";
                  modal.classList.remove("show");
              }
          },
          OpenGallery: function(){
              let Gallery = document.getElementById("gallery-box");
              if(Gallery !== null){
                  //items.style.display = "";
                  Gallery.classList.add("show");
              }
          },
  
          CloseSpecs(){
              let modal = document.getElementById("specs-box");
              if(modal !== null){
                  //modal.style.display = "none";
                  modal.classList.remove("show");
              }
          },
          OpenSpecs: function(){
              let Specs = document.getElementById("specs-box");
              if(Specs !== null){
                  //items.style.display = "";
                  Specs.classList.add("show");
              }
          },

          OpenVirtual: function(){
              let virtual = document.getElementById("virtual-box");
              if(virtual !== null){
                  //items.style.display = "";
                  virtual.classList.add("show");
              }
          },
          CloseVirtual(){
              let modal = document.getElementById("virtual-box");
              if(modal !== null){
                  //modal.style.display = "none";
                  modal.classList.remove("show");
              }
          },
  
          CloseLocation(){
              let location = document.getElementById("location-box");
              if(location !== null){
                  //modal.style.display = "none";
                  location.classList.remove("show");
              }
          },
          OpenLocation: function(){
              let location = document.getElementById("location-box");
              if(location !== null){
                  //items.style.display = "";
                  location.classList.add("show");
              }
          },
  
      }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style  lang="scss">
  
  
  .SideMenuButton {
      cursor: pointer;
  }
  
  .router-link-active span {
      color:#cad636 
  }
  
  .nav-active{
      color:#cad636
  }
  
  .arrow {
      cursor:pointer;
  }
  
  .footer {
      height: 70px;
      background-color: #381b31;
      color: white;
      width: 100%!important;
      div {
          width: calc(100%/8);
          span {
              border: none !important;
          }
      }
  
      :nth-child(4) {
          width:17% !important 
      }
  
      .footer-box {
          text-transform: uppercase;
          a{
              color: #fff;
              text-decoration: none;
              border: none;
          }
          .footer-icons {
              width: 30px !important;
              height: 30px !important;
              object-fit: contain;
              margin-right: 10px;
          }
  
          .star {
              margin-right: 30px !important;
          }
  
          .name{
              letter-spacing:3px;
              font-size: 13px;
              font-weight:700
          }
          
          .item-box{
              display:none !important;
              position: absolute;
              top: -60px;
              left:0;
              height: 60px;
              border-radius: 0 20px 0px 0px;
              background: #64a7a6;
              width: 300px;
              z-index:5;
              div{
                  width: 100%;
                  height: 60px;
                  border: none;
                  padding: 0;
  
                  div{
                      width:calc(100% / 4)
                  }
  
                  .active-box{
                      background-color: #1F3646 !important;
                  }
                  
                  .arrow{
                      background-color: #64a7a6;
                      border-radius: 0 20px 0px 0px;
                  }
  
                  .inner-icons{
                      width: 30px;
                  }
  
                 
              }
          }
  
          .gallery-box{
              display: none !important;
              position: absolute;
              top: -60px;
              left: 0;
              height: 60px;
              border-radius: 0 20px 0px 0px;
              background: #64a7a6;
              width: 300px;
              div{
                  width: 100%;
                  height: 60px;
                  border: none;
                  padding: 0;
                  div{
                      width:calc(100% / 4)
                  }
  
                  .active-box{
                      background-color: #1F3646 !important;
                  }
                  
                  .arrow{
                      background-color: #64a7a6;
                      border-radius: 0 20px 0px 0px;
                  }
  
                  .inner-icons{
                      width: 30px;
                  }
              }
          }
  
          .specs-box{
              display: none !important;
              position: absolute;
              top: -60px;
              left: 0;
              height: 60px;
              border-radius: 0 20px 0px 0px;
              background: #64a7a6;
              width: 300px;
              div{
                  width: 100%;
                  height: 60px;
                  border: none;
                  padding: 0;
                  div{
                      width:calc(100% / 4)
                  }
  
                  .active-box{
                      background-color: #1F3646 !important;
                  }
                  
                  .arrow{
                      background-color: #64a7a6;
                      border-radius: 0 20px 0px 0px;
                  }
  
                  .inner-icons{
                      width: 30px;
                  }
  
                 
              }
          }

          .virtual-box{
              display: none !important;
              position: absolute;
              top: -60px;
              left: 0;
              height: 60px;
              border-radius: 0 20px 0px 0px;
              background: #64a7a6;
              width: 300px;
              cursor:pointer;
              div{
                  width: 100%;
                  height: 60px;
                  border: none;
                  padding: 0;
                  div{
                      width:calc(100% / 4)
                  }
  
                  .active-box{
                      background-color: #1F3646 !important;
                  }
                  
                  .arrow{
                      background-color: #64a7a6;
                      border-radius: 0 20px 0px 0px;
                  }
  
                  .inner-icons{
                      width: 30px;
                  }
  
                 
              }
          }
  
          .location-box{
              display: none !important;
              position: absolute;
              top: -60px;
              left: 0;
              height: 60px;
              border-radius: 0 20px 0px 0px;
              background: #64a7a6;
              width: 300px;
              cursor:pointer;
              div{
                  width: 100%;
                  height: 60px;
                  border: none;
                  padding: 0;
                  div{
                      width:calc(100% / 4)
                  }
                  .active-box{
                      background-color: #1F3646 !important;
                  }
                  .arrow{
                      background-color: #64a7a6;
                      border-radius: 0 20px 0px 0px;
                  }
                  .inner-icons{
                      width: 30px;
                  }
              }
          }
  
          .show{
              display:block !important
          }
  
          .leaf {
                  height: 30px;
                  width: auto !important; 
              }
  
          &:hover{
              .item-box{
                  display: block;
              }
              .gallery-box{
                  display: block;
              }
              .specs-box{
                  display: block;
              }
  
              .location-box{
                  display: block;
              }
          }
          
      }
  
      .footer-img {
          height: 100%;
          img {
              width: 100%;
              height: 100%;
              object-fit:cover;
          }
      }
  
      .rightfooter{
          text-align:center;
          vertical-align: middle;
           img {
              width: auto !important;
              height: 60px !important;
              margin-top: 5px;
              padding: 3px;
          }
      }
  }
  
  
  .footer-active {
      background-color: #1F3646 !important;
      height: 100%;
  }
  
  
  
  .mobile-show  {
      display: none;
  }
  
  
  @media screen and (max-width: 1366px) {
  
  }
  
  
  @media screen and (max-width: 1100px) {
      .name {
          display: none;
      }
  
      .footer {
          div {
              width: calc(100%/5);
          }
  
          .footer-box {
              .footer-icons {
                  margin: 0;
              }
              .item-box{
                  left: 0;
              }
              .gallery-box{
                  left: 0;
              }
              .specs-box{
                  left: 0;
              }
  
              .location-box{
                  left: 0;
              }
          }
      }
  }
  
  @media screen and (max-width: 800px) {
      .footer-img {
          display: none;
      }
  
      .favourites{display:none}
  }
  
  @media screen and (max-width: 800px) {
      .mobile-hide  {
          display: none;
      }
  
      .mobile-show  {
          display: block;
      }
  }
  
  
  
  
  
  </style>
  